import { TicketFormAdmin } from './TicketFormAdmin'
import { TicketFormProducer } from './TicketFormProducer'

const TicketForm = { Admin: TicketFormAdmin, Producer: TicketFormProducer }

export default TicketForm
